import React from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem4sm6xs12,
} from '../../../business-components/Grid/Grid'

import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import familiaList from '../../../business-rules/List/familiaList'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoProjetoVidaSonho,
    rowPertentePageProjetoVidaSonho,
    setPageInclusaoProjetoVidaSonho,
} from './ProjetoVidaSonhoCompProjetoVidaSonho'

import {
    incrementaContProjetoVidaSonho,
    processaRegistrosDefaultIniciaisProjetoVidaSonho,
    calculaTotaisProjetoVidaSonho,
} from './ProjetoVidaSonhoServiceProjetoVidaSonho'

import ProjetoVidaSonhoFormProjetoVidaSonhoItem from './ProjetoVidaSonhoFormProjetoVidaSonhoItem'



const ProjetoVidaSonhoFormProjetoVidaSonho = ({ values, handleChange, setFieldValue, linhaTipoLicenca }) => {

    calculaTotaisProjetoVidaSonho(values)

    useSingleton(async () => {

        values.pageProjetoVidaSonho = obtemPage(values.pageProjetoVidaSonhoList, Number.parseInt(values.familiarProjetoVidaSonho))
    })

    salvaPage(values.pageProjetoVidaSonho, values.pageProjetoVidaSonhoList, Number.parseInt(values.familiarProjetoVidaSonho))

    let indAux = 0

    values.projetoVidaSonhoPagination = 
        values.projetoVidaSonho
            ?
                values.projetoVidaSonho.filter(item => item.familiar === Number.parseInt(values.familiarProjetoVidaSonho))
            :
                []



    return (
        <>
            <PanelRadioGroup
                name="familiarProjetoVidaSonho"
                value={Number.parseInt(values.familiarProjetoVidaSonho) || ''}
                onChange={(e) => {
                    values.pageProjetoVidaSonho = obtemPage(values.pageProjetoVidaSonhoList, Number.parseInt(e.target.value))
                    handleChange(e)
                }}
                list={values.totalProjetoVidaSonho}
                onBlur={
                    processaRegistrosDefaultIniciaisProjetoVidaSonho(values,
                        Number.parseInt(values.familiarProjetoVidaSonho))
                }
                helpText={HELPTEXT.projetoVidaSonhoPanelRadioGroup}
            />
               
            <FieldArray name="projetoVidaSonho">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.projetoVidaSonho?.map((item, ind) => {

                                return item.familiar === Number.parseInt(values.familiarProjetoVidaSonho) &&
                                rowPertentePageProjetoVidaSonho(values, indAux++) ? (
                                    <GridItem4sm6xs12
                                        key={ind}
                                    >
                                        <ProjetoVidaSonhoFormProjetoVidaSonhoItem
                                            values={values}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            arrayHelpers={arrayHelpers}
                                            linhaTipoLicenca={linhaTipoLicenca}
                                            item={item}
                                            ind={ind}
                                            simplificado={false}
                                        />
                                    </GridItem4sm6xs12>
                                )
                                :
                                (
                                   ''
                                )}
                            )}
                        </GridContainer>

                        <TablePaginationPadraoProjetoVidaSonho
                            values={values}
                            setFieldValue={setFieldValue}
                        />

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirProjetoVidaSonho} 
                            disabled={familiaList(values).length === 0 || !values.familiarProjetoVidaSonho ? true : false}
                            onClick={() =>
                                {
                                    incrementaContProjetoVidaSonho(values)
                                    arrayHelpers.push({
                                        id: values.contProjetoVidaSonho,
                                        familiar: Number.parseInt(values.familiarProjetoVidaSonho)
                                    })
                                    setPageInclusaoProjetoVidaSonho(values, setFieldValue)
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </>
    )
}

export default ProjetoVidaSonhoFormProjetoVidaSonho